/**
 * The microphone as speech recognition wants it: one channel, cleaned up by
 * the browser. A chosen device is asked for exactly rather than as a
 * preference: a browser handed a preference falls back to the built-in
 * microphone in silence, which is what somebody who picked a headset avoided.
 */
export function voiceMicrophoneConstraints(
  deviceId: string | null,
): MediaTrackConstraints {
  return {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
    channelCount: 1,
    ...(deviceId === null ? {} : { deviceId: { exact: deviceId } }),
  };
}
